import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  standalone: false,
  template: `<span class="skeleton" [style.width]="width" [style.height]="height" [style.borderRadius]="radius"></span>`,
})
export class Skeleton {
  @Input() width = '100%';
  @Input() height = '16px';
  @Input() radius = '4px';
}
